export default __webpack_public_path__ + "static/media/Image-7.ed676656.png";